// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Css from "bs-css-emotion/src/Css.bs.js";
import * as Curry from "rescript/lib/es6/curry.js";
import * as React from "react";
import * as StyleConstants$LiveRoom from "../styles/StyleConstants.bs.js";

function getStreamContainerStyles(showStream, floatStream) {
  if (showStream) {
    if (floatStream) {
      return Curry._1(Css.style, {
                  hd: Css.top(Css.px(StyleConstants$LiveRoom.headerHeight)),
                  tl: {
                    hd: Css.right(Css.zero),
                    tl: {
                      hd: Css.width(Css.px(StyleConstants$LiveRoom.sidebarsWidth)),
                      tl: {
                        hd: Css.zIndex(202),
                        tl: {
                          hd: Css.position(Css.fixed),
                          tl: /* [] */0
                        }
                      }
                    }
                  }
                });
    } else {
      return Curry._1(Css.style, {
                  hd: Css.width(Css.pct(100)),
                  tl: {
                    hd: Css.height(Css.pct(100)),
                    tl: {
                      hd: Css.maxWidth(Css.px(1000)),
                      tl: {
                        hd: Css.margin("auto"),
                        tl: /* [] */0
                      }
                    }
                  }
                });
    }
  } else {
    return Curry._1(Css.style, {
                hd: Css.top(Css.px(StyleConstants$LiveRoom.headerHeight)),
                tl: {
                  hd: Css.right(Css.px(0)),
                  tl: {
                    hd: Css.width(Css.px(StyleConstants$LiveRoom.sidebarsWidth - 2 | 0)),
                    tl: {
                      hd: Css.zIndex(202),
                      tl: {
                        hd: Css.padding4(Css.px(8), Css.px(16), Css.px(8), Css.px(8)),
                        tl: {
                          hd: Css.position(Css.fixed),
                          tl: /* [] */0
                        }
                      }
                    }
                  }
                }
              });
  }
}

function StreamContainer(props) {
  var children = props.children;
  var getContainerHeight = props.getContainerHeight;
  var floatStream = props.floatStream;
  var showStream = props.showStream;
  var getContainerHeight$1 = getContainerHeight !== undefined ? getContainerHeight : (function (param) {
        
      });
  var match = React.useState(function () {
        return 0;
      });
  var setFloatingStreamContainerHeight = match[1];
  var floatingStreamContainerHeight = match[0];
  var handleResize = function (param) {
    if (!floatStream) {
      return ;
    }
    var element = document.getElementById("stream-container");
    var streamContainerHeight = (element == null) ? 0 : element.getBoundingClientRect().height;
    Curry._1(setFloatingStreamContainerHeight, (function (param) {
            return streamContainerHeight;
          }));
  };
  React.useEffect((function () {
          if (showStream) {
            handleResize(undefined);
            window.addEventListener("resize", handleResize);
          } else {
            window.removeEventListener("resize", handleResize);
          }
        }), [showStream]);
  React.useEffect((function () {
          Curry._1(getContainerHeight$1, floatingStreamContainerHeight);
        }), [floatingStreamContainerHeight]);
  React.useEffect((function () {
          if (showStream && floatStream) {
            var element = document.getElementById("stream-container");
            var streamContainerHeight = (element == null) ? 0 : element.getBoundingClientRect().height;
            Curry._1(setFloatingStreamContainerHeight, (function (param) {
                    return streamContainerHeight;
                  }));
          } else {
            Curry._1(setFloatingStreamContainerHeight, (function (param) {
                    return 0;
                  }));
          }
        }), [
        showStream,
        floatStream,
        children
      ]);
  return React.createElement("div", {
              className: getStreamContainerStyles(showStream, floatStream),
              id: "stream-container"
            }, children);
}

var make = StreamContainer;

export {
  getStreamContainerStyles ,
  make ,
}
/* Css Not a pure module */
